// extracted by mini-css-extract-plugin
module.exports = {"h2":"IndexMdxProvider-module--h2--2GjG8 fonts-module--titilium24--20fuH","ul":"IndexMdxProvider-module--ul--35uks"};